module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms2.19a2b070ba3a7a6c87c8a8bd20c87c24.png";